/*
 * Pseudo-localization has two approaches and each is only applied to certain locales.
 */
const pseudoLocalesForI18n = ['pl-xx', 'ar-xx', 'zh-cn-pseudo'];
const pseudoLocalesForL10n = ['it-it-pseudo', 'fr-fr-pseudo', 'de-de-pseudo', 'es-es-pseudo', 'pl-pl-pseudo', 'ru-ru-pseudo', 'lt-lt-pseudo'];
export const isPseudoLocaleForI18n = locale => {
  return pseudoLocalesForI18n.includes(locale.toLowerCase());
};
export const isPseudoLocaleForL10n = locale => {
  return pseudoLocalesForL10n.includes(locale.toLowerCase());
};

/**
 * Dynamically get the pseudoI18 API.
 */
export const getPseudoI18n = async () => {
  return import('./pseudoI18n');
};

/**
 * Dynamically get the pseudoL10n API.
 */
export const getPseudoL10n = async () => {
  return import('./pseudoL10n');
};
//# sourceMappingURL=index.js.map